module.exports = __webpack_public_path__ + "img/1570909229.cf69d4d7.jpg";